/** @format */

export interface AnalyticsEvtData {
  ecode: string;
}
